// Country card game data with rankings
export const COUNTRY_CARDS = [
  {
    "id": 1,
    "name": "India",
    "rank": 1,
    "image": "/images/country/country_1.jpg"
  },
  {
    "id": 2,
    "name": "China",
    "rank": 2,
    "image": "/images/country/country_2.jpg"
  },
  {
    "id": 3,
    "name": "United States",
    "rank": 3,
    "image": "/images/country/country_3.jpg"
  },
  {
    "id": 4,
    "name": "Indonesia",
    "rank": 4,
    "image": "/images/country/country_4.jpg"
  },
  {
    "id": 5,
    "name": "Pakistan",
    "rank": 5,
    "image": "/images/country/country_5.jpg"
  },
  {
    "id": 6,
    "name": "Nigeria",
    "rank": 6,
    "image": "/images/country/country_6.jpg"
  },
  {
    "id": 7,
    "name": "Brazil",
    "rank": 7,
    "image": "/images/country/country_7.jpg"
  },
  {
    "id": 8,
    "name": "Bangladesh",
    "rank": 8,
    "image": "/images/country/country_8.jpg"
  },
  {
    "id": 9,
    "name": "Russia",
    "rank": 9,
    "image": "/images/country/country_9.jpg"
  },
  {
    "id": 10,
    "name": "Mexico",
    "rank": 10,
    "image": "/images/country/country_10.jpg"
  },
  {
    "id": 11,
    "name": "Japan",
    "rank": 11,
    "image": "/images/country/country_11.jpg"
  },
  {
    "id": 12,
    "name": "Philippines",
    "rank": 12,
    "image": "/images/country/country_12.jpg"
  },
  {
    "id": 13,
    "name": "Congo",
    "rank": 13,
    "image": "/images/country/country_13.jpg"
  },
  {
    "id": 14,
    "name": "Ethiopia",
    "rank": 14,
    "image": "/images/country/country_14.jpg"
  },
  {
    "id": 15,
    "name": "Egypt",
    "rank": 15,
    "image": "/images/country/country_15.jpg"
  },
  {
    "id": 16,
    "name": "Vietnam",
    "rank": 16,
    "image": "/images/country/country_16.jpg"
  },
  {
    "id": 17,
    "name": "Iran",
    "rank": 17,
    "image": "/images/country/country_17.jpg"
  },
  {
    "id": 18,
    "name": "Turkey",
    "rank": 18,
    "image": "/images/country/country_18.jpg"
  },
  {
    "id": 19,
    "name": "Germany",
    "rank": 19,
    "image": "/images/country/country_19.jpg"
  },
  {
    "id": 20,
    "name": "United Kingdom",
    "rank": 20,
    "image": "/images/country/country_20.jpg"
  },
  {
    "id": 21,
    "name": "France",
    "rank": 21,
    "image": "/images/country/country_21.jpg"
  },
  {
    "id": 22,
    "name": "Tanzania",
    "rank": 22,
    "image": "/images/country/country_22.jpg"
  },
  {
    "id": 23,
    "name": "Thailand",
    "rank": 23,
    "image": "/images/country/country_23.jpg"
  },
  {
    "id": 24,
    "name": "South Africa",
    "rank": 24,
    "image": "/images/country/country_24.jpg"
  },
  {
    "id": 25,
    "name": "Italy",
    "rank": 25,
    "image": "/images/country/country_25.jpg"
  },
  {
    "id": 26,
    "name": "Kenya",
    "rank": 26,
    "image": "/images/country/country_26.jpg"
  },
  {
    "id": 27,
    "name": "Colombia",
    "rank": 27,
    "image": "/images/country/country_27.jpg"
  },
  {
    "id": 28,
    "name": "Sudan",
    "rank": 28,
    "image": "/images/country/country_28.jpg"
  },
  {
    "id": 29,
    "name": "Myanmar",
    "rank": 29,
    "image": "/images/country/country_29.jpg"
  },
  {
    "id": 30,
    "name": "South Korea",
    "rank": 30,
    "image": "/images/country/country_30.jpg"
  }
];
